<template>
    <div class="prepay-detail">
        <h3>评级详情</h3>
        <el-form :model="levelInfo" ref="levelInfo" class="demo-form-inline" size="mini" label-width="180px">
            <div v-for="group,groupKey in levelInfo" :key="`group${groupKey}`">
                <h4>{{group.groupName}}</h4>
                <el-form-item v-for="item,itemKey in group.list" :label="item.label" :key="`item${itemKey}`" :prop="`${groupKey}.list[${itemKey}][${item.name}]`" :rules="Array.from(rules[item.name] || [])">
                    <template v-if="item.type == 'text'">{{item[item.name]}}</template>
                    <template v-else-if="item.type == 'radio'">
                        <el-radio-group v-model="item[item.name]">
                            <el-radio v-for="option in item.options" :label="Number(option.value)" :key="option.value">{{option.label}}</el-radio>
                        </el-radio-group>
                    </template>
                    <template v-else-if="item.type == 'input'">
                        <el-input type="text" v-model="item[item.name]"></el-input>
                    </template>
                </el-form-item>
            </div>
            <el-form-item label="">
                <el-button type="primary" @click="submit('save')">保存</el-button>
                <el-button type="primary" @click="submit('calculate')">计算评分</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import api from '../api'
let {
    interview,
} = api

export default {
    name: "levelDetail",
    data() {
        return {
            levelInfo: {},
            rules: {},
            updateOrInsertKey: '',
            updateOrInsertValue: 0,
        };
    },
    computed: {
        id() {
            return this.$route.query.id
        },
    },
    watch: {},
    mounted() {
        this.getDetail()
    },
    methods: {
        async getDetail() {

            let obj = {
                userId: this.id
            }
            let res = await interview.detail(obj)
            let {
                code,
                data
            } = res.data;

            if (code == 200) {
                this.levelInfo = data.data;
                this.rules = data.rules;
                this.updateOrInsertKey = data.updateOrInsertKey;
                this.updateOrInsertValue = data.updateOrInsertValue;
                console.log(data);
            }

        },
        submit(action) {
            console.log(this.levelInfo)
            if (this.levelInfo['基础信息'].list[4].interviewerStatus === 3) {
                this.update(action)
            } else {
                this.$refs['levelInfo'].validate(valid => {
                    if (valid) {
                        this.update(action)
                    } else {
                        return false;
                    }
                })
            }

        },
        async update(action) {
            let obj = {
                updateOrInsertKey: this.updateOrInsertKey,
                updateOrInsertValue: this.updateOrInsertValue,
                data: this.levelInfo,
                rules: null,
            }
            let {
                data: {
                    code,
                    data
                }
            } = await interview[action](obj);
            if (code === 200) {
                this.$message.success('更新成功');
                if (action == 'save') {
                    this.getDetail();
                } else {
                    this.levelInfo = data.data;
                }
            }
        },
    },
};
</script>
<style scoped>
.demo-form-inline {
    width: 640px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/level-detail.vue